<template>
<v-container fluid class="page-wrap">
    <v-row class="noprint" v-if="!studentsheetForm && !broadsheetForm">
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">RESULTS</div>
                        <div class="text-h6 font-weight-bold primary--text">Result Sheets</div>
                        <div class="text-body-2 grey--text">View and Print Results</div>
                    </div>
                </v-card-title>
                <v-card-text v-if="fetchingContent">
                    <info-loader-2/>
                </v-card-text>
                <v-card-text v-else>
                    <v-row>
                        <v-col cols="12" sm="6" v-if="authToken">
                            <v-card outlined class="rounded-lg sheet-choice-card pa-4" @click="showBroadsheetForm">
                                <div class="d-flex align-center">
                                    <v-avatar size="48" class="sheet-choice-icon mr-4" rounded>
                                        <v-icon color="white">mdi-table-large</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="text-subtitle-1 font-weight-bold primary--text">Broadsheet</div>
                                        <div class="text-caption grey--text">Class-wide score summary across all subjects</div>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-icon color="grey">mdi-chevron-right</v-icon>
                                </div>
                            </v-card>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-card outlined class="rounded-lg sheet-choice-card pa-4" @click="showStudentsheetForm">
                                <div class="d-flex align-center">
                                    <v-avatar size="48" class="sheet-choice-icon mr-4" rounded>
                                        <v-icon color="white">mdi-file-account-outline</v-icon>
                                    </v-avatar>
                                    <div>
                                        <div class="text-subtitle-1 font-weight-bold primary--text">Student Report Sheets</div>
                                        <div class="text-caption grey--text">View and print individual student report cards</div>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-icon color="grey">mdi-chevron-right</v-icon>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-if="authToken">
                    <v-alert
                        type="info"
                        dense
                        border="left"
                        text
                        color="orange"
                        >
                        <marquee>
                            <span v-for="(info,i) in infos" :key="i" class="black--text mr-5">
                            {{info.content}} | &nbsp;
                            </span>
                        </marquee>
                    </v-alert>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
        <v-col cols="12">
            <v-card-text>
                <student-result-sheet-modal v-if="studentsheetForm && reRenderComponent" :accessToken="accessToken" :authToken="authToken" :school="school" :classes="classes" :terms="terms" :gradings="gradings" :userType="userType"/>

                <broad-sheet-modal v-if="broadsheetForm && reRenderComponent" :accessToken="accessToken" :authToken="authToken" :school="school" :classes="classes" :terms="terms" :gradings="gradings"/>
            </v-card-text>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
import StudentResultSheetModal from '../../components/sheets/StudentResultSheetModal.vue';
import BroadSheetModal from '../../components/sheets/BroadSheetModal.vue';
import InfoLoader2 from '../../components/InfoLoader2.vue';
  export default {
    name: 'ResultSheets',
    components: {
        HeaderVue,
        StudentResultSheetModal,
        BroadSheetModal,
        InfoLoader2
    },
    mounted() {
       this.fetchTerms()
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        accessToken:sessionStorage.getItem('accessToken') ?? null,
        userType:sessionStorage.getItem('utpc') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : {},
        broadsheetForm: false,
        studentsheetForm: false,
        reRenderComponent: true,
        classes:[],
        terms:[],
        gradings:[],
        infos:[
            {content: 'Be sure to have recorded scores before proceeding to view result sheets.'},
            {content: 'If you get a Result not found message means that there are no results for that class for that term you selected.'},
            {content: 'If results preview is empty, then that student does not have results for the class and term.'},
        ],
        fetchingContent:true
    }),
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ],
        link: [
            { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Lato:300,400,500,700' }
        ],
    },
    methods: {
        showBroadsheetForm () {
            this.broadsheetForm = !this.broadsheetForm
            this.studentsheetForm = false
        },
        showStudentsheetForm () {
            this.broadsheetForm = false
            this.studentsheetForm = !this.studentsheetForm
        },
        fetchTerms () {
            axios.get(process.env.VUE_APP_BASEURL+'/parameters?school_id='+this.school.school_id+'&type=dropdown',
            {
                headers:
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
            })
            .then((response) => {
                this.terms =  response.data.data
                if (this.terms.length == 0) {
                    this.$toast.info('You will need to set a session/term first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Terms'})
                }
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    localStorage.removeItem('authToken')
                }
                this.$toast.error(error.response ? error.response.data.message : 'APP is temporarily unavailable. Wait or Contact us!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchClasses()
                this.fetchGradings()
            });
        },
        fetchClasses () {
            axios.get(process.env.VUE_APP_BASEURL+'/classes?school_id='+this.school.school_id+'&type=dropdown',
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'X-Access-Token': this.accessToken,
                }
            })
            .then((response) => {
                this.classes =  response.data.data
                this.fetchingContent = false;
                 if (this.classes.length == 0) {
                    this.$toast.info('You will need to set classes first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Classes'})
                }
                this.reRenderComponent = false;
                this.$nextTick(() => {
                // Add the component back in
                this.reRenderComponent = true;
                });
            })
            .catch((error) => {
                this.$toast.error(error.response ? error.response.data.message : 'Internet Network Not Available!', {
                    timeout: 5000
                });
            })
            .finally(() => {
                this.fetchingContent = false;
            });
        },
        fetchGradings () {
            axios.get(process.env.VUE_APP_BASEURL+'/grades?school_id='+this.school.school_id,
            {
                headers:
                {
                    'Authorization': 'Bearer '+this.authToken,
                    'X-Access-Token': this.accessToken,
                }
            })
            .then((response) => {
                this.gradings =  response.data.data
                if (this.gradings.length == 0) {
                    this.$toast.info('You will need to set your grading system first!', {
                            timeout: 5000
                        });
                    this.$router.push({name: 'Grades'})
                }
            })
            .catch((error) => {
                console.log(error.response.status)
            })
            .finally(() => {
            });
        },
    },
  }
</script>

<style scoped>
.sheet-choice-card {
    border: 1px solid #ECEFF7;
    cursor: pointer;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}
.sheet-choice-card:hover {
    box-shadow: 0 4px 24px rgba(30, 60, 114, 0.12) !important;
    transform: translateY(-2px);
}
.sheet-choice-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
</style>

<style>
@media print{
    @page {size: A4 auto}
    .noprint {
        display: none !important;
    }
    .v-sheet.v-stepper:not(.v-sheet--outlined) {
        border: none !important;
        box-shadow: none !important;
    }
    .v-card{
        box-shadow: none !important;
    }
    .container, .row, .v-stepper__content, .v-main{
        margin: 0 !important;
        padding: 0 !important;
    }
    .col{
        padding: 0 0 0 2px !important;
    }
    .print-area{
        left: 0;
        top: 0;
        margin: 0;
        padding: 0;
        visibility: visible !important;
    }
}
</style>
